
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import VueSimpleAlert from "vue-simple-alert";
import colors from "vuetify/lib/util/colors";

import "vuetify/dist/vuetify.min.css";
import VueRouter from 'vue-router'
import VueApexCharts from 'vue-apexcharts'

import MobilePanel from "./components/PortalComponents/MobilePanel.vue";
import LandingPanel from "./components/PortalComponents/LandingPanel.vue";
import ReportTable from "./components/PortalComponents/ReportTable.vue";
import AlertPanel from "./components/PortalComponents/AlertPanel.vue";
import axios from "axios";

Vue.use(Vuetify);
Vue.use(VueRouter);
Vue.use(VueApexCharts);
Vue.use(VueSimpleAlert);
Vue.use(require('vue-moment'));

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    dark: true, // Set dark mode as default
    themes: {
      light: {
        primary: "#35363b",
        secondary: colors.grey.darken1,
        accent: colors.shades.black,
        error: colors.red.accent3,
        background: colors.indigo.lighten5, // Not automatically applied
        // colours from maintel's design document 11-11-2024
        "maintel-dark-green": "#82A62D",
        "maintel-light-green": "#D8F591",
        "maintel-green": "#B2D952",
        "maintel-grey": "#E6E6E6",
        "maintel-black": "#263339",

        // these are from maintel's _variables 1.scss sent to us by mike@maintel
        "maintel-info": "#64c2c9",
        info : "#64c2c9",
        "maintel-danger": "#f64e60",
        "maintel-warning": "#e57e0f",
        warning: "#e57e0f",
        "maintel-caution": "#dfbd03",
        "maintel-success": "#5cb85c",
        "maintel-contrast2" : "#d4d6df"
      },
      dark: {
        primary: "#eaf2fb",
        secondary: colors.orange,
        background: colors.red,
        // colours from maintel's design document 11-11-2024
        "maintel-dark-green": "#82A62D",
        "maintel-light-green": "#D8F591",
        "maintel-green": "#B2D952",
        "maintel-grey": "#E6E6E6",
        "maintel-black": "#263339",

        // these are from maintel's _variables 1.scss sent to us by mike@maintel
        "maintel-info": "#64c2c9",
        info : "#64c2c9",
        "maintel-danger": "#f64e60",
        "maintel-warning": "#e57e0f",
        warning: "#e57e0f",
        "maintel-caution": "#dfbd03",
        "maintel-success": "#5cb85c",
        "maintel-contrast2": "#2c414b",
        "maintel-dark": "#f8f8f8",
      },
    },
  },
})

const routes = [
  { path: '/landing', component: LandingPanel },
  { path: '/table/:tablename/:initialSearchValue?', component: ReportTable },
  { path: '/mobile/:mobilenumber', name: 'mobile', component: MobilePanel },
  { path: '/alerts', name: 'alerts', component: AlertPanel }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

axios
  .get("/api/mbe/settings")
  .then((response) => {

    console.log("Got settings ", response);
    Vue.prototype.$settings = response.data;
    // rjd: set everything to admin as we want to ignore roles for now.
    Vue.prototype.$settings.roles = ["mp_admin"];
    console.log("main.js:roles is now:", Vue.prototype.$settings.roles);
  })
  .catch((error) => {
    alert(error);
  });

router.beforeEach((to, from, next) => {

  console.log("to", to.path);
  console.log("from", from);

  let settings = Vue.prototype.$settings;
  var attemptingAccessReadAlertState = false;

  switch (to.path) {
    case "/alerts":
      {
        attemptingAccessReadAlertState = true;
        break
      };
    case "/table/portal_alert": {
      if (!(settings.roles.includes('mp_admin') ||
        settings.roles.includes('mp_alertmanager'))) {
        next("/landing");
      }
      break
    };
    case "/table/alert_record": {
      attemptingAccessReadAlertState = true;
      break
    };
    case "/table/delete_alert_audit_line": {
      attemptingAccessReadAlertState = true;
      break
    };
    case "/table/read_alert_audit_line": {
      attemptingAccessReadAlertState = true;
      break
    };
  }

  // If attempting access to read alert state but do not have appropriate role -> redirect to landing.
  if (attemptingAccessReadAlertState && !(
    settings.roles.includes('mp_alert_readonly') ||
    settings.roles.includes(
      'mp_selfservice_alert_readonly'
    ) ||
    settings.roles.includes('mp_alertmanager') ||
    settings.roles.includes('mp_admin'))) {

    next("/landing")

  } else {

    // Non alert state.  Roles do not matter. Can visit.
    next();
  }
});

new Vue({
  vuetify: new Vuetify(),
  render: h => h(App),
  router
}).$mount('#app')

